'use strict';
var validate_cb_1ormore = require('../common/validate-checkables-atleastone');
var validateTextField = require('../common/validate-textfield');
var validateMaxLength = require('../common/validate-maxlength');
var validateSelect = require('../common/validate-select');
var validateEmail = require('../common/validate-email');
var recaptcha = require('../common/recaptcha');

module.exports = {
	init: function () {
		if (window.jQuery('#signup').length > 0) {
			window.jQuery('#signup').on('submit', validateSignup);

			window.jQuery('#signup').on('change', '#gender', toggleGenderOther);
			toggleGenderOther();

			window.jQuery('#signup').on('click', '.relationship-checkbox', togglePrefClassYear);
			togglePrefClassYear();

			//if the email address is changed, we need to re-validate it
			window.jQuery('#prefemailaddress').on('change keyup', () => {
				window.jQuery('#prefemailaddress').removeClass('emailIsValid');
			});
		}
	}
};

function resumeSignup(token) {
	window.jQuery('#signup').submit();
}

function validateSignup() {
	const defaultEmailError = `<i class="fa fa-fw fa-exclamation-triangle"></i> Email address is required`;
	window.jQuery('#prefemailaddress').closest('.errorContainer').find('.errorIcon').html(defaultEmailError);

	var error = false;
	error = validate_cb_1ormore('#relationships') || error;
	error = validateTextField('.requireText') || error;
	error = validateMaxLength('.hasMaxLength') || error;
	error = validateSelect('.requireSelect') || error;
	if (error) {
		window.alert('Please make a selection in all fields marked in red');
	}

	if (error) {
		recaptcha.reset();
		return false;
	} else {
		const $submit = window.jQuery('#signup button[type=submit]');
		const emailIsValid = validateEmail('#prefemailaddress', 'emailIsValid', '#signup', $submit);
		if (!emailIsValid) {
			recaptcha.reset();
			return false;
		} else {
			if (recaptcha.getToken() === '') {
				//the argument tells it to re-run this function once recaptcha execution completes
				recaptcha.execute(resumeSignup);
				return false;
			} else {
				//captcha complete, resume submit
				return true;
			}
		}
	}
}

function toggleGenderOther() {
	var $this = window.jQuery('#gender');
	var $selfDescription = window.jQuery('#gender_other');

	if ($this.find('option:checked').data('other')) {
		$selfDescription.removeClass('hide');
	} else {
		$selfDescription.addClass('hide');
	}
}

function togglePrefClassYear() {
	var $box = window.jQuery('#prefclassyear').closest('.form-group');
	var show = false;
	window.jQuery('.relationship-checkbox:checked').each(function (ix, chk) {
		if (window.jQuery(chk).data('showprefclassyear')) {
			show = true;
		}
	});
	if (show) {
		$box.show();
	} else {
		$box.hide();
	}
}
